import { ModalErrorIcon, ModalSuccessIcon, ModalWarningIcon } from '@/consts/svg-img';
import i18n from '@/i18n';
import { Collapse } from 'antd';
import React, { ReactNode, useEffect, useRef } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import styled from 'styled-components';
interface IProps {
  type: 'error' | 'success' | 'warning';
  show: boolean;
  title?: string;
  text?: string | ReactNode;
  onClose?: () => any;
  hideIcon?: boolean;
  footer?: ReactNode;
  timeout?: number;
  width?: string;
  minWidth?: string;
  content?: ReactNode;
  details?: string;
}

export const getTransDetail = (detail: any) => {
  let details = '';
  try {
    if (detail) {
      for (const key in detail) {
        if (detail.hasOwnProperty(key)) {
          details += `[${key}]: ${detail[key]} <br />`;
        }
      }
    }
  } catch (e) {
    console.log('error: get trans details', e);
    details = '';
  }
  return details;
};

const VModal = (props: IProps) => {
  const {
    details,
    type,
    show,
    title,
    width,
    text,
    content,
    minWidth,
    onClose = () => {},
    hideIcon = false,
    footer,
    timeout = 0,
  } = props;
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <img src={ModalSuccessIcon} />;
      case 'error':
        return <img src={ModalErrorIcon} />;
      case 'warning':
        return <img src={ModalWarningIcon} />;
      default:
        return undefined;
    }
  };

  useEffect(() => {
    let myTimer: any = null;
    if (show && timeout > 0) {
      myTimer = setTimeout(function() {
        console.log('call VModal close function');
        onClose();
      }, timeout);
      console.log('init VModal timer', myTimer, timeout);
    }
    return () => {
      if (myTimer) {
        console.log('clear VModal timer');
        clearTimeout(myTimer);
        myTimer = null;
      }
    };
  }, [show]);

  return (
    <SweetAlert
      style={{ width: width || '300px', minWidth: details ? '330px' : '120px' }}
      // timeout={2000}
      show={show}
      title={''}
      customClass="sweet-alert-custom"
      showConfirm={false}
      onConfirm={onClose}
    >
      <ModalBody>
        {!hideIcon && <div className="v-modal__icon">{getIcon()}</div>}
        {title && <div className="v-modal__title">{title}</div>}
        {text && <div className="v-modal__text">{text}</div>}
        {content}
        {details && (
          <Collapse className="v-modal__details">
            <Collapse.Panel header={i18n.t('common.details')} key="1">
              <div dangerouslySetInnerHTML={{ __html: details }}></div>
            </Collapse.Panel>
          </Collapse>
        )}
        {footer && <div className="v-modal__buttons">{footer}</div>}
      </ModalBody>
    </SweetAlert>
  );
};

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 120px;
  .v-modal {
    &__title {
      font-family: 'VFont-Bold';
      font-size: 18px;
      margin-top: 20px;
      text-align: center;
    }
    &__text {
      font-family: 'VFont';
      font-size: 14px;
      margin-top: 15px;
      color: #666666;
      text-align: center;
      .em {
        font-family: 'VFont-Bold';
      }
    }
    &__buttons {
      margin-top: 15px;
      display: flex;
      .not-first-child {
        margin-left: 15px;
      }
    }
    &__details {
      margin-top: 15px;
      text-align: left;
    }
  }
`;

export default VModal;
